export const toNumber = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : 0;
};

export const calcSplit = (preSplit, split) => {
  const percent = toNumber(split?.percent);

  if (!split || percent <= 0) {
    return { share: 0, final: preSplit };
  }

  const share = (preSplit * percent) / 100;
  return { share, final: preSplit - share };
};

export const toSplitForm = (split) =>
  split?.userId ? { userId: split.userId, name: split.name || "", percent: split.percent } : null;

export const isSplitValid = (split) => !split || (!!split.userId && toNumber(split.percent) > 0);

export const toSplitPayload = (split) => (split ? { userId: split.userId, percent: toNumber(split.percent) } : null);
